__turbopack_context__.v({
  "circle": "ComponentDatasheetActions-Public-module-scss-module__ECCmja__circle",
});
